module.exports = __webpack_public_path__ + "img/002.5d79653b.png";